/* @flow */

import history from "../uidispatcherapi/BettyHistoryModule";

export function isFsdShop() {
    return getShopFlavor() === "fsd";
}

export function isStoreShop() {
    return getShopFlavor() === "store";
}

export function getShopFlavor() {
    if (typeof history.getShopFlavor === "function") {
        return history.getShopFlavor();
    }
    return null;
}
